import { isArray } from 'lodash/lang'
import { mapActions, mapState } from 'vuex'
import { NAMESPACE } from '@argon/app/store'

export default {
  name: 'Datatable',
  data: function () {
    return {
      page: 1,
      itemsPerPage: 10,
      itemsPerPageArray: [10, 25, 50],
      sortBy: null,
      sortDesc: false
    }
  },
  computed: {
    ...mapState(NAMESPACE, ['appliedFilters']),
    filterObject() {
      return this.appliedFilters[this.context]
    },
    filterItems() {
      return this.filterObject ? this.filterObject.items : []
    },
    filterStamp() {
      return this.filterObject ? this.filterObject.stamp : null
    },
    computedSortBy() {
      return isArray(this.sortBy) ? this.sortBy[0] : this.sortBy
    },
    computedSortDesc() {
      return isArray(this.sortDesc) ? this.sortDesc[0] : this.sortDesc
    },
    pager() {
      return {
        page: this.page,
        per_page: this.itemsPerPage,
        sort_by: this.computedSortBy,
        sort_desc: this.computedSortDesc
      }
    }
  },
  watch: {
    page: function (v) {
      this.fetchData()
    },
    itemsPerPage: function (newValue, oldValue) {
      if (newValue === oldValue) return
      this.fetchData()
    },
    sortBy: function (newValue, oldValue) {
      if (newValue === oldValue) return
      this.fetchData()
    },
    sortDesc: function (newValue, oldValue) {
      if (newValue === oldValue) return
      this.fetchData()
    },
    filterStamp: function (v) {
      if (this.page > 1) {
        this.page = 1 // This triggers a fetchData()
      } else {
        this.fetchData()
      }
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['setAppliedFilters']),
    fetchData() {},
    setFilterObject(filterObject) {
      this.setAppliedFilter({ context: this.context, filterObject })
    }
  },
  created() {
    this.fetchData()
  }
}
